import Css from "../../style.module.scss";

import { FormElement } from "nlib/common/Form";
import { getTextsData } from "selectors/texts";
import { useSelector } from "react-redux";
import Checkbox from "nlib/ui/Checkbox";
import IntegrationServices from "const/IntegrationServices";
import React from "react";

const DocumentsTab = ({ rpaMode, integrationService }) => {
  const { messages } = useSelector(getTextsData);

  const quickBooksDesktopBusiness = integrationService === IntegrationServices.QUICK_BOOKS_DESKTOP.value;

  return (
    <>
      {!quickBooksDesktopBusiness && !rpaMode && (
        <div className={Css.row}>
          <FormElement
            toggle
            name="advancedDocumentsWorkflow"
            element={Checkbox}>
            <span>{messages.advancedDocumentWorkflowToggleLabelText}</span>
          </FormElement>
        </div>
      )}
      <div className={Css.row}>
        <FormElement
          toggle
          name="recognizeDocumentLineItems"
          element={Checkbox}>
          <span>{messages.recogniseLineItemsToggleLabelText}</span>
        </FormElement>
      </div>
      {!rpaMode && (
        <div className={Css.row}>
          <FormElement
            toggle
            name="allowAutoCreatePayee"
            element={Checkbox}>
            <span>{messages.autoCreatePayeeToggleLabelText}</span>
          </FormElement>
        </div>
      )}
    </>
  );
};

export default React.memo(DocumentsTab);
